/**
 * Headline metrics. The single source of truth for numbers that the site quotes
 * in multiple places. If you ever need to bump a number, change it here — not
 * across six data files.
 *
 * The literal "10,000" / "10,000+" / "Partner Creators" must appear nowhere else
 * in the codebase except inside long-form FAQ prose. Extend this object when a
 * new metric starts appearing in more than one file.
 */
export const METRICS = {
  totalCreators: {
    value: 10000,
    display: { en: '10,000+', fa: '۱۰،۰۰۰+' },
    label: { en: 'Partner Creators', fa: 'کریتور شریک' },
  },
} as const
